import Dexie, { Table } from "dexie";
import { Address } from "@/types/address.types";
import { Log } from "@/types/log.types";
import { QSO } from "@/types/qso.types";

export class QSOAddressPrinterDB extends Dexie {
  addresses!: Table<Address, string>;
  qsos!: Table<QSO, string>;
  logs!: Table<Log, string>;

  constructor() {
    super("QSOAddressPrinter");
    this.version(1).stores({
      addresses: "id, call, status, createdAt",
      qsos: "id, call, qso_date, qsl_rcvd",
      logs: "id, operation, resource, status, createdAt",
    });
  }
}

export const db = new QSOAddressPrinterDB();
